class FGProductHeaderActions extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const fgFavoritesBtn = this.querySelector('[data-fg-favorites-btn]');
        const fgWishlistBtn = this.querySelector('[data-fg-wishlist-btn]');
        const fgQuickViewBtn = this.querySelector('[data-fg-quick-view-btn]');

        if (fgFavoritesBtn) {
            fgFavoritesBtn.addEventListener('click', event => {
                const element = event.currentTarget;
                if (!(element instanceof HTMLElement)) return;

                const isToggled = element.dataset.toggled === 'true';
                if (isToggled) {
                    element.setAttribute('data-toggled', 'false');
                } else {
                    element.setAttribute('data-toggled', 'true');
                }
            });
        }

        if (fgWishlistBtn) {
            fgWishlistBtn.addEventListener('click', event => {
                const element = event.currentTarget;
                if (!(element instanceof HTMLElement)) return;

                const isToggled = element.dataset.toggled === 'true';
                if (isToggled) {
                    element.setAttribute('data-toggled', 'false');
                } else {
                    element.setAttribute('data-toggled', 'true');
                }
            });
        }

        if (fgQuickViewBtn) {
            fgQuickViewBtn.addEventListener('click', event => {
                const element = event.currentTarget;
                if (!(element instanceof HTMLElement)) return;
                try {
                    if (!element.dataset.packProducts) return;
                    const products = JSON.parse(element.dataset.packProducts);
                    console.log(products);
                }
                catch (e) {
                    console.error('Could not parse pack products', e);
                }
            });
        }
    }
}

if (!customElements.get('fg-product-header-actions')) {
    customElements.define('fg-product-header-actions', FGProductHeaderActions);
}